import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Container, Stack } from '@mui/material';
import SelfReporting from './pages/SelfReporting';

const App: React.FC = () => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <BrowserRouter>
      <Box sx={{ display: 'flex' }}>
        <AppBar position="fixed">
          <Toolbar
            sx={{
              background: 'linear-gradient(90deg, #C94BD2 0%, #4AA9EC 100%)',
            }}
          >
            <Stack flexDirection="row" sx={{ gap: 3 }}>
              <Typography variant="h6" onClick={handleReload} noWrap sx={{ flexGrow: 1, fontWeight: 'bold', cursor: 'pointer' }}>
                KOLs.Asia
              </Typography>
              <Typography
                variant="h6"
                onClick={handleReload}
                noWrap
                sx={{ flexGrow: 1, marginLeft: '10px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                Insights Submission
              </Typography>
            </Stack>
          </Toolbar>
        </AppBar>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: 'background.default',
            paddingTop: 8,
            paddingLeft: 2,
            paddingRight: 2,
          }}
        >
          <Container maxWidth="lg">
            <Switch>
              <Route path="/self-reporting" component={SelfReporting} />
              <Redirect to="/self-reporting" />
            </Switch>
          </Container>
        </Box>
      </Box>
    </BrowserRouter>
  );
};

export default App;
